import { REPLY_DRAFT_COPY } from '../copy';

import { Button, ButtonText } from '@/components/ui/button';
import { HStack } from '@/components/ui/hstack';
import { Text } from '@/components/ui/text';
import { VStack } from '@/components/ui/vstack';
import { getAccessibilityProps } from '@/util/accessibilityProps';

/**
 * Asked in place of "use draft" when the expert edited an earlier hand-off in
 * the message box. Their edits are theirs, so the draft never overwrites them
 * without a yes.
 */
export function ReplaceConfirm({
  onReplace,
  onKeep,
}: {
  onReplace: () => void;
  onKeep: () => void;
}) {
  return (
    <VStack
      className="gap-3 px-4 pb-4 pt-8"
      testID="reply-draft-replace-confirm"
      accessibilityLiveRegion="polite">
      <VStack className="gap-1">
        <Text size="sm" className="font-semibold text-typography-900">
          {REPLY_DRAFT_COPY.replaceHeading}
        </Text>
        <Text size="sm" className="text-typography-700">
          {REPLY_DRAFT_COPY.replaceBody}
        </Text>
      </VStack>

      <HStack className="gap-3">
        <Button
          size="lg"
          variant="outline"
          action="secondary"
          className="min-h-12 flex-1"
          onPress={onKeep}
          testID="reply-draft-keep-mine"
          {...getAccessibilityProps({ role: 'button', label: REPLY_DRAFT_COPY.keepMine })}>
          <ButtonText className="text-secondary-700">{REPLY_DRAFT_COPY.keepMine}</ButtonText>
        </Button>

        <Button
          size="lg"
          action="primary"
          className="min-h-12 flex-1"
          onPress={onReplace}
          testID="reply-draft-replace"
          {...getAccessibilityProps({ role: 'button', label: REPLY_DRAFT_COPY.replace })}>
          <ButtonText>{REPLY_DRAFT_COPY.replace}</ButtonText>
        </Button>
      </HStack>
    </VStack>
  );
}
